import { useState } from "react";
import { Lock, Eye, EyeOff } from "lucide-react";

/**
 * LoginForm - Email/Password login form component
 */
export default function LoginForm({ 
  email, 
  onSubmit, 
  onBack, 
  loading,
  error 
}) {
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!password) return;
    onSubmit(password);
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div className="p-3 bg-gray-50 rounded-lg">
        <p className="text-sm text-gray-600">
          Signing in as <strong>{email}</strong>
        </p>
      </div>
      
      {error && (
        <div className="p-3 bg-red-50 border border-red-200 rounded-lg text-sm text-red-700">
          {error}
        </div>
      )}
      
      <div className="relative">
        <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" />
        <input
          type={showPassword ? "text" : "password"}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Enter your password"
          className="w-full pl-10 pr-12 py-3 rounded-xl border border-gray-200 focus:ring-2 focus:ring-brand/20 focus:border-brand"
          data-testid="modal-password-input"
          required
        />
        <button
          type="button"
          onClick={() => setShowPassword(!showPassword)}
          className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
        >
          {showPassword ? <EyeOff className="w-5 h-5" /> : <Eye className="w-5 h-5" />}
        </button>
      </div>
      
      <button
        type="submit"
        disabled={loading || !password}
        className="w-full py-3 bg-brand text-white rounded-xl font-medium hover:bg-brand-dark transition-colors disabled:opacity-50"
        data-testid="modal-login-btn"
      >
        {loading ? "Signing in..." : "Sign In"}
      </button>
      
      <button
        type="button"
        onClick={onBack}
        className="w-full text-gray-500 hover:text-gray-700 text-sm"
      >
        ← Use a different email
      </button>
    </form>
  );
}
